export const DATA_TABLE_ROW_HEIGHT = 48;
export const DATA_TABLE_ROW_HEIGHT_PX = `${DATA_TABLE_ROW_HEIGHT}px`;

export const DATA_TABLE_ROW_HEIGHT_SMALL = 32;
export const DATA_TABLE_ROW_HEIGHT_PX_SMALL = `${DATA_TABLE_ROW_HEIGHT_SMALL}px`;

export const DATA_TABLE_ROW_HEIGHT_LARGE = 64;
export const DATA_TABLE_ROW_HEIGHT_PX_LARGE = `${DATA_TABLE_ROW_HEIGHT_LARGE}px`;

export const DATA_TABLE_TOOLBAR_HEIGHT = 52;
export const DATA_TABLE_TOOLBAR_HEIGHT_PX = `${DATA_TABLE_TOOLBAR_HEIGHT}px`;
export const DATA_TABLE_SECONDARY_TOOLBAR_HEIGHT = 34;
export const DATA_TABLE_SECONDARY_TOOLBAR_HEIGHT_PX = `${DATA_TABLE_SECONDARY_TOOLBAR_HEIGHT}px`;
export const DATA_TABLE_PAGINATOR_HEIGHT = 65;
export const DATA_TABLE_PAGINATOR_HEIGHT_PX = `${DATA_TABLE_PAGINATOR_HEIGHT}px`;
export const DATA_TABLE_QUICK_REPORTS_HEIGHT = 80;
export const DATA_TABLE_QUICK_REPORTS_HEIGHT_PX = `${DATA_TABLE_QUICK_REPORTS_HEIGHT}px`;

export const defaultColumn = {
  maxSize: 30, // minWidth is only used as a limit for resizing
  size: 150, // width is used for both the flex-basis and flex-grow
  minSize: 200
};
